// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"2134":"08ba3e2c","2228":"6ad1e7be","6076":"17c9c145","8590":"22393b8c","9330":"6c32bb5a"}[chunkId] + ".css";
};